import { render, staticRenderFns } from "./OrderEmision.vue?vue&type=template&id=6ba09db4"
import script from "./OrderEmision.vue?vue&type=script&lang=js"
export * from "./OrderEmision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports